import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getManagementState, ManagementState } from '../management.reducer';
import { adapter, ItemTypesState } from './item-types.reducer';
import {ItemType} from '@emm/core/models/item-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getManagementState, (state: ManagementState) => state.itemTypes);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedTag = createSelector(getState, (state: ItemTypesState) => state.selectedTag);
const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedTag,
    (entities, selectedTag) => selectedTag && entities[selectedTag]
);
const getValidAll = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);
const getSearchFilter = createSelector(getState, (state: ItemTypesState) => state.searchFilter);
const getFilteredItemTypes = createSelector(
    getValidAll,
    getSearchFilter,
    (itemTypes: ItemType[], filter: SearchFilter) => {
        const useFilter =
            RA.isNonEmptyArray(itemTypes) &&
            RA.isNotNilOrEmpty(filter) &&
            RA.isNonEmptyString(filter.key) &&
            RA.isNotNil(filter.value);

        const filterString = (filter?.value as string)?.toLowerCase();

        const filteredItems = itemTypes?.filter((item: ItemType) => {
            if (filter?.key === 'classTag') {
                return item[filter?.key] && item[filter?.key].toLowerCase() === filterString;
            } else {
                return item[filter?.key] && item[filter?.key].toLowerCase().includes(filterString);
            }
        });

        return useFilter ? filteredItems : itemTypes;
    }
);

export const ItemTypesSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getSelectedTag,
    getSelected,
    getValidAll,
    getSearchFilter,
    getFilteredItemTypes
};
